import Page from 'component/Page';
import FormControls from 'component/FormControls';
import { useEffect, useMemo, useState } from 'react';
import sendRequest, { sendPost, sendPut } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import Table from 'component/Table';
import Modal from 'component/Modal';
import PocChannelAdd from './PocChannelAdd';
import PocChannelUpdate from './PocChannelUpdate';
import Register from 'page/register/Register';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';
import { useHistory } from 'react-router-dom';
import Paths from 'util/paths';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { useCallback } from 'react';
import { getRemainingTime, add1Year2Date, formatLocalDate, formatDate, nNU, showConfirm, showToast, formatMinutes } from 'util/utils';
import { FaUserGroup } from 'react-icons/fa6';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

const PocChannelList = () => {
  //-------------------------------HOOKS-------------------------------------------------------------
  const currentUser = useSelector(selectCurrentUser);
  const [ channels, setChannels ] = useState([]);
  const [ page, setPage ] = useState(1);
  const [ total, setTotal ] = useState(0);
  const [ pageSize, setPageSize ] = useState(10);
  const [ searchId, setSearchId ] = useState('');
  const [ debouncedSearchId, setDebouncedSearchId ] = useState(searchId);

  const [ selectedChannel, setSelectedChannel ] = useState(null);
  const [ addChannel, setAddChannel ] = useState(null);
  const [ register, setRegister ] = useState(null);
  const isAdmin = useMemo(
    () => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
    [ currentUser.accountRole ]
  );
  const isMonitorOnly = useMemo(
    () => currentUser.isMonitorOnly === 1,
    [ currentUser.isMonitorOnly ]
  );
  const formControls = [];
  const history = useHistory();
	const headers = isAdmin ? [
		string.POC_CHANNEL_NAME,
		string.POC_CHANNEL_ID,
		// string.POC_CHANNEL_SIP,
		string.POC_CHANNEL_OWNER,
		string.POC_CHANNEL_PLAN_TYPE,
		string.POC_CHANNEL_REMAINING_TIME,
		string.POC_CHANNEL_VALID_UNTIL,
		string.POC_CHANNEL_ASSIGN,
		string.POC_CHANNEL_MEMBER,
		string.POC_CHANNEL_HOST,
		string.POC_CHANNEL_REGISTERED_DATE,
		string.POC_CHANNEL_UPDATE_STATUS_DATE,
	] : [
		string.POC_CHANNEL_NAME,
		string.POC_CHANNEL_ID,
		string.POC_CHANNEL_PLAN_TYPE,
		string.POC_CHANNEL_REMAINING_TIME,
		string.POC_CHANNEL_VALID_UNTIL,
		string.POC_CHANNEL_ASSIGN,
		// string.POC_CHANNEL_REGISTER_TITLE,
		string.POC_CHANNEL_MEMBER,
		string.POC_CHANNEL_HOST,
		string.POC_CHANNEL_REGISTERED_DATE,
		string.POC_CHANNEL_UPDATE_STATUS_DATE,
	];

  //------------------------------FUNCTIONS----------------------------------------------------------
  const doSearch = useCallback(
    async (page, pageSize, searchKeyword, getAll = false) => {
      if (!nNU(currentUser.id)) {
        return;
      }
      let data = await sendPost({
        url: isAdmin ? Urls.pocchannel.list : Urls.pocchannel.userlist,
        body: {
          id: currentUser.id,
          offset: (page - 1) * pageSize,
          size: pageSize,
          keyword: searchKeyword,
        },
      });
      const { total, result } = data;
      if (!getAll) {
        setChannels(result);
        setTotal(total);
        // console.log(total);
      }
      return result;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ currentUser ]
  );
  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchId(searchId);
    }, 500);
    return () => {
      clearTimeout(timerId);
    };
  }, [ searchId ]);
  // useEffect(() => {
  //   const hideToasts = () => {
  //     hideToast()
  //   };
  //   const timerId = setTimeout(hideToasts, 6000);
  //   return () => {
  //     clearTimeout(timerId);
  //   };
  // }, []);

  useEffect(() => {
    doSearch(page, pageSize, debouncedSearchId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ page, pageSize, debouncedSearchId, doSearch ]);
  const dataTable = useCallback(
    (data) =>
      data.map((raw, key) => ({
        key: raw.groupId,
        data: isAdmin ? [
					raw.groupName,
					raw?.groupId.toString().padStart(6, '0'),
					// raw.confSipNumber,
					nNU(raw.email) ? raw.email : currentUser.email,
					raw.status === 0 ? string.POC_CHANNEL_PLAN_TYPE_DISABLE :
						raw.planType === 0 ? string.POC_CHANNEL_PLAN_TYPE_MONTHLY_PAID : string.POC_CHANNEL_PLAN_TYPE_PREPAID,
					(raw?.status === 1) && (raw?.planType === 1) ? formatMinutes(raw?.remainingTime > 60 ? raw?.remainingTime - 60:0) : "-",
					(raw?.status === 1) && (raw?.planType === 1) && nNU(raw?.remainingTimeSetDate)? formatLocalDate(add1Year2Date(formatLocalDate(raw?.remainingTimeSetDate,'YYYY/MM/DD')), 'YYYY/MM/DD') : "-",
					((raw?.status === 0) || (raw?.planType === 1)) && nNU(raw?.pendingVolume) && (raw?.pendingVolume > 0) ? formatMinutes(getRemainingTime(raw?.pendingVolume)) : "-",
					raw.status === 1 ? (
						<OverlayTrigger
							placement="top"
							overlay={
								raw.status === 1 && (
									<Tooltip>{`${raw.groupName}の${string.POC_CHANNEL_MEMBER}一覧へ`}</Tooltip>
								)
							}
						>
							<Button
								style={{
									padding: '3px',
									minWidth: '4.5em',
									display: 'flex',
									justifyContent: 'center',
								}}
								id={raw.groupId}
								onClick={(e) => onChannelClick(e)}
							>
								{/* <FaUserGroup /> */}
								{raw.totalMembers}
							</Button>
						</OverlayTrigger>
					) : null,
					raw.status === 1 ? (
						<OverlayTrigger
							placement="top"
							overlay={
								raw.status === 1 && (
									<Tooltip>{`${raw.groupName}の${string.POC_CHANNEL_HOST}設定へ`}</Tooltip>
								)
							}
						>
							<Button
								style={{
									padding: '3px',
									minWidth: '6.5em',
									display: 'flex',
									justifyContent: 'center',
								}}
								id={raw.groupId}
								onClick={(e) => onChannelHostClick(e)}
							>
								{/* <FaUserGroup /> */}
								{!!nNU(raw.adminUsername) ? raw.adminUsername : '-'}
							</Button>
						</OverlayTrigger>
					) : null,
					formatDate(raw.registerDate, 'YYYY/MM/DD'),
					nNU(raw.updateStatusDate)
						? formatDate(raw.updateStatusDate, 'YYYY/MM/DD')
						: formatDate(raw.registerDate, 'YYYY/MM/DD'),
				] : [
					raw.groupName,
					raw?.groupId.toString().padStart(6, '0'),
					raw.status === 0 ? string.POC_CHANNEL_PLAN_TYPE_DISABLE :
						raw.planType === 0 ? string.POC_CHANNEL_PLAN_TYPE_MONTHLY_PAID : string.POC_CHANNEL_PLAN_TYPE_PREPAID,
					(raw?.status === 1) && (raw?.planType === 1) ? formatMinutes(raw?.remainingTime > 60 ? raw?.remainingTime - 60:0) : "-",
					(raw?.status === 1) && (raw?.planType === 1) && nNU(raw?.remainingTimeSetDate)? formatLocalDate(add1Year2Date(formatLocalDate(raw?.remainingTimeSetDate,'YYYY/MM/DD')), 'YYYY/MM/DD') : "-",
					((raw?.status === 0) || (raw?.planType === 1)) && nNU(raw?.pendingVolume) && (raw?.pendingVolume > 0) ? formatMinutes(getRemainingTime(raw?.pendingVolume)) : "-",
					raw.status === 1 ? (
						<OverlayTrigger
							placement="top"
							overlay={
								raw.status === 1 && (
									<Tooltip>{`${raw.groupName}の${string.POC_CHANNEL_MEMBER}一覧へ`}</Tooltip>
								)
							}
						>
							<Button
								style={{
									padding: '3px',
									minWidth: '4.5em',
									display: 'flex',
									justifyContent: 'center',
								}}
								id={raw.groupId}
								onClick={(e) => onChannelClick(e)}
							>
								{/* <FaUserGroup /> */}
								{raw.totalMembers}
							</Button>
						</OverlayTrigger>
					) : null,
					raw.status === 1 ? (
						<OverlayTrigger
							placement="top"
							overlay={
								raw.status === 1 && (
									<Tooltip>{`${raw.groupName}の${string.POC_CHANNEL_HOST}設定へ`}</Tooltip>
								)
							}
						>
							<Button
								style={{
									padding: '3px',
									minWidth: '6.5em',
									display: 'flex',
									justifyContent: 'center',
								}}
								id={raw.groupId}
								onClick={(e) => onChannelHostClick(e)}
							>
								{/* <FaUserGroup /> */}
								{!!nNU(raw.adminUsername) ? raw.adminUsername : '-'}
							</Button>
						</OverlayTrigger>
					) : null,
					formatDate(raw.registerDate, 'YYYY/MM/DD'),
					nNU(raw.updateStatusDate)
						? formatDate(raw.updateStatusDate, 'YYYY/MM/DD')
						: formatDate(raw.registerDate, 'YYYY/MM/DD'),
				],
				raw,
      })),
    []
  );
  const mainActions = isMonitorOnly ? [] : [
		{
			icon: 'add',
			title: string.POC_CHANNEL_CREATE_TITLE,
			onClick: () => setAddChannel({ valid: true }),
		},
  ];
  const actions = isMonitorOnly ? [] : [
		{ render: 'edit', onClick: ({ raw }) => setSelectedChannel(raw) },
		({ raw }) => {
			if (!isAdmin) {
				return null;
			}
			if (raw.status === 1) {
				return {
					render: 'ban',
					className: 'color-danger',
					onClick: ({ raw }) => {
						// console.log('Ban');
						let channel = {
							groupId: raw.groupId,
							status: 0,
							planType: 0,
						};
						showConfirm({
							body: string.POC_CHANNEL_DELETE_CONFIRM,
							defaultAction: () => {
								sendPut({
									url: Urls.pocchannel.status,
									body: channel,
								})
									.then((res) => {
										showToast(string.POC_CHANNEL_DELETE_SUCCESS, 'success');
										doSearch(page, pageSize);
									})
									.catch((e) => {
										console.log('削除エラー');
									});
							},
						});
					},
				};
			} else {
				return {
					render: 'approve',
					onClick: ({ raw }) => {
						// console.log('Approve');
						let channel = {
							groupId: raw.groupId,
							status: 1,
						};
						showConfirm({
							body: string.POC_CHANNEL_APPROVE_CONFIRM,
							defaultAction: () => {
								sendPut({
									url: Urls.pocchannel.status,
									body: channel,
								})
									.then((res) => {
										showToast(
											string.POC_CHANNEL_APPROVE_SUCCESS,
											'success'
										);
										doSearch(page, pageSize);
									})
									.catch((e) => {
										console.log('承認エラー');
									});
							},
						});
					},
				};
			}
		},
  ];
  const onChannelClick = (e) => {
    // console.log(e.currentTarget.id);
    let id = e.currentTarget.id;
    history.push(`${Paths.pocchannel.detail}/?id=${id}`);
  };
  const onChannelHostClick = (e) => {
    // console.log(e.currentTarget.id);
    let id = e.currentTarget.id;
    history.push(`${Paths.pocchannel.host}/?id=${id}`);
  };
  const onChannelRegisterClick = async (e) => {
    let id = e.currentTarget.id;
    let data = await sendRequest({
      url: `${Urls.pocchannel.channel}/${id}`,
    });
    const { result } = data;
    setRegister(result);
  };

  //-------------------------------RETURN------------------------------------------------------------
  return (
    <>
      <Page
        title={string.POC_CHANNEL_MANAGEMENT}
        body={
          <>
            <FormControls controls={formControls} />
            <Table
              className="nowrap"
              mainActions={mainActions}
              page={page}
              pageSize={pageSize}
              total={total}
              onPageChanged={setPage}
              onPageSizeChanged={setPageSize}
              headers={headers}
              data={dataTable(channels)}
              getCSVData={!isMonitorOnly && (async () => {
                return dataTable(await doSearch(1, total, null, true));
              })}
              csvFileName="SecretChannelList"
              isPaging={true}
              actions={actions}
              search={true}
              onSearch={(value) => setSearchId(value)}
              placeHolder={`${string.POC_CHANNEL_NAME}`}
            />
          </>
        }
      />
      <Modal
        show={!!selectedChannel}
        onHide={() => setSelectedChannel(null)}
        body={
          <>
            {!!selectedChannel && (
              <PocChannelUpdate
                onUpdated={() => {
                  setSelectedChannel(null);
                  doSearch(page, pageSize);
                }}
                data={selectedChannel}
              />
            )}
          </>
        }
      />

      <Modal
        show={!!addChannel}
        onHide={() => setAddChannel(null)}
        body={
          <>
            {!!addChannel && (
              <PocChannelAdd
                onUpdated={() => {
                  setAddChannel(null);
                  doSearch(page, pageSize);
                }}
                data={addChannel}
              />
            )}
          </>
        }
      />

      <Modal
        show={!!register}
        onHide={() => setRegister(null)}
        body={
          <>
            {!!register && (
              <Register
                onUpdated={() => {
                  setRegister(null);
                  doSearch(page, pageSize);
                }}
                data={register}
              />
            )}
          </>
        }
      />
    </>
  );
};

export default PocChannelList;
